export const HTTP_HANDLER_ID = 'http';
export const WEBSOCKET_HANDLER_ID = 'websocket';
export const GRAPHQL_WS_HANDLER_ID = 'graphql-ws';
export const APP_SYNC_HANDLER_ID = 'app-sync';
export const ACTION_CABLE_HANDLER_ID = 'action-cable';
export const GRAPHQL_SSE_HANDLER_ID = 'graphql-sse';
